import { isURL } from 'class-validator';

const getValidURL = (url: string | undefined, defaultUrl: string): string => {
  return url && isURL(url) ? url : defaultUrl;
};

const urlsConfig = {
  webServerBaseURL: getValidURL(window.WEB_BACKEND_URL, 'http://192.168.1.134:4075/etecubeApi'),
  storageServerURL: getValidURL(window.STORAGE_SERVER_URL, 'http://127.0.0.1:4085'),
  hymotsServerBaseURL: getValidURL(window.HYMOTS_C_URL, 'http://127.0.0.1:4006/api'),
  exportServerBaseURL: getValidURL(window.EXPORT_BACKEND_URL, 'http://127.0.0.1:5006/api'),
  fileServerBaseUrl: getValidURL(window.FILE_SERVER_URL, 'http://localhost:1234'),
  mmuUrl: window.MMU_URL && !window.MMU_URL.startsWith('{{') ? window.MMU_URL : 'ws://127.0.0.1:4111/',
  hymotsEUrl:
    window.HYMOTS_E_URL && !window.HYMOTS_E_URL.startsWith('{{') ? window.HYMOTS_E_URL : 'ws://127.0.0.1:4140',
  nginrUrl: window.NGINR_URL && !window.NGINR_URL.startsWith('{{') ? window.NGINR_URL : 'http://10.3.0.100:3000',
  appBaseURL: getValidURL(window.APP_BASE_URL, 'http://127.0.0.1:3000/'),
  layersServerURL: getValidURL(window.LAYERS_SERVER_URL, 'http://127.0.0.1:4011/'),
  nginrEmailMessengerURL: getValidURL(window.NGINR_EMAIL_MESSENGER_URL, 'http://127.0.0.1:9514/messenger'),
  layersServer: 'layers_server',

  systemLogin:
    window.LOGIN_SYSTEM && !window.LOGIN_SYSTEM.startsWith('{{')
      ? window.LOGIN_SYSTEM.toUpperCase() === 'ENABLED'
      : true,

  officeConfig: window.OFFICE_CONFIG && !window.OFFICE_CONFIG.startsWith('{{') ? window.OFFICE_CONFIG === 'YES' : false,

  phase: {
    base: '/phase',
    lookupPhase: '/phase',
    phaseCreate: '/phase',
    phaseEdit: '/phase',
    phaseDelete: '/phase',
  },

  lineOfEffort: {
    base: '/lineofeffort',
    lookupLineOfEffort: '/lineofeffort',
    lineOfEffortCreate: '/lineofeffort',
    lineOfEffortEdit: '/lineofeffort',
    lineOfEffortDelete: '/lineofeffort',
    lineOfEffort: '/lineofeffort',
    allLineOfEffortList: '/lineofeffort/lineOfEffortAll',
    odReport: 'lineofeffort/ODReport',
  },
  lineOfEffortofontology: {
    lookupLineOfEffortOfOntology: '/lineOfEffortOfOntology',
  },
  lineOfEffortOftrainingObjective: {
    lookupLineOfEffortOfObjective: '/lineOfEffortOfObjective',
  },
  planOrderReportProcess: {
    base: '/planOrderReport',
    lookupPlanOrderReportProcess: '/planOrderReport',
    planOrderReportProcessCreate: '/planOrderReport',
    planOrderReportProcessEdit: '/planOrderReport',
    planOrderReportProcessDelete: '/planOrderReport',
    planOrderReportProcess: '/planOrderReport',
  },
  planOrderReportProcessOfontology: {
    lookupPlanOrderReportProcessOfOntology: '/planOrderReportProcessOfOntology',
  },
  user: {
    lookupUser: '/users',
    lookupUserTable: '/users/table',
    createUser: '/users',
    deleteUser: '/users',
    editUser: '/users',
    login: '/users/login',
    getMe: '/users/@me',
    updateMePassword: '/users/@me/password',
    updateMeProfile: '/users/@me/profile',
    updateMeLanguage: '/users/@me/language',
    users: '/users',
    getUserNames: '/users/usernames',
    getAllUserNames: '/users/allUsernames',
  },

  userofontology: {
    lookupUserOfOntology: '/userofontology',
  },

  userofevent: {
    lookupUserOfEvent: '/userofevent',
  },

  helpAndSupport: {
    docRaw: '/help-and-support/docRaw',
    docRawMil: '/help-and-support/docRawMil',
  },

  ontology: {
    base: '/ontology',
    lookupOntology: '/ontology',
    ontologiesOfEvent: '/eventOntology',
    bulkRemoveFromEvent: '/eventOntology/bulkRemoveFromEvent',
    ontologyAdd: '/ontology',
    ontologyEdit: '/ontology',
    ontologyDelete: '/ontology',
    ontology: '/ontology',
  },

  event: {
    base: '/event',
    lookupEvent: '/event',
    eventCreate: '/event',
    eventEdit: '/event',
    eventDelete: '/event',
    select: '/event/select',
    database: '/event/database',
    replicate: '/event/replicate',
    updateForbiddenModule: '/event/updateForbiddenModule',
    importJEMMData: '/event/importJEMMData',
    importEfesUsersData: '/event/importEfesUsersData',
  },

  userRights: {
    base: '/userRights',
    lookupUserRights: '/userRights',
    createUserRights: '/userRights',
    UserRightsEdit: '/userRights',
    UserRightsDelete: '/userRights',
  },

  incidentFolder: {
    base: '/incident-folder',
    lookupIncidentFolder: '/incident-folder',
    incidentFolderAdd: '/incident-folder',
    incidentFolderdit: '/incident-folder',
    incidentFolderDelete: '/incident-folder',
  },

  workPackage: {
    base: '/work-package',
    lookupWorkPackage: '/work-package',
    workPackageAdd: '/work-package',
    workPackageEdit: '/work-package',
    workPackageDelete: '/work-package',
  },

  incident: {
    base: '/incident',
    lookupIncident: '/incident',
    lookupIncidentTable: '/incident/table',
    createIncident: '/incident',
    incidentEdit: '/incident',
    incidentMapPositionEdit: '/incident/map-position',
    incidentDelete: '/incident',
    allIncidentList: '/incident/incidentAll',
  },

  task: {
    base: '/task',
    lookupTask: '/task',
    lookupTaskOfOntology: '/task/taskofontology',
    lookupTaskOfCCR: '/task/taskofccr',
    lookupTaskOfTT: '/task/taskoftt',
    createTask: '/task',
    taskEdit: '/task',
    taskDelete: '/task',
  },
  effect: {
    base: '/effect',
    lookupEffect: '/effect',
    createEffect: '/effect',
    effectEdit: '/effect',
    effectDelete: '/effect',
  },

  odTask: {
    base: '/od-task',
    lookupOdTask: '/od-task',
    createOdTask: '/od-task',
    odTaskEdit: '/od-task',
    odTaskDelete: '/od-task',
    lookupOdTaskOfSupportingOntology: '/od-task/od-task-of-supporting-ontology',
    lookupOdTaskOfResponsibleOntology: '/od-task/od-task-of-responsible-ontology',
    odTaskEditOverwrite: '/od-task/overwrite',
  },

  turnChart: {
    base: '/turn-chart',
    lookupTurnChart: '/turn-chart',
    createTurnChart: '/turn-chart',
    editTurnChart: '/turn-chart',
    deleteTurnChart: '/turn-chart',
    turnChartOfDecisiveConditions: '/turn-chart/turn-chart-of-decisive-conditions',
    turnChartOfEffects: '/turn-chart/turn-chart-of-effects',
    turnChartOfTasks: '/turn-chart/turn-chart-of-tasks',
    turnChartOfRisks: '/turn-chart/turn-chart-of-risks',
  },

  decisiveCondition: {
    base: '/decisive-condition',
    lookupDecisiveCondition: '/decisive-condition',
    lookupDecisiveConditionTable: '/decisive-condition/table',
    createDecisiveCondition: '/decisive-condition',
    decisiveConditionEdit: '/decisive-condition',
    decisiveConditionDelete: '/decisive-condition',
  },

  incidentofontology: {
    lookupIncidentOfOntology: '/incidentofontology',
  },

  incidentoftrainingObjective: {
    lookupIncidentOfTrainingObjective: '/incidentoftrainingObjective',
  },

  injection: {
    base: '/injection',
    lookupInjection: '/injection',
    lookupInjectionTable: '/injection/table',
    createInjection: '/injection',
    injectionEdit: '/injection',
    injectionDelete: '/injection',
    injectionAllList: '/injection/incident',
  },

  projectInput: {
    base: '/project-input',
    lookupProjectInput: '/project-input',
    lookupProjectInputTable: '/project-input',
    lookupProjectInputOntology: '/project-input/project-input-of-ontology',
    createProjectInput: '/project-input',
    projectInputEdit: '/project-input',
    projectInputDelete: '/project-input',
  },

  project: {
    base: '/projects',
    lookupProject: '/projects',
    createProject: '/projects',
    projectEdit: '/projects',
    projectDelete: '/projects',
  },

  injectionofontology: {
    lookupInjectionOfOntology: '/injectionofontology',
  },

  action: {
    base: '/action',
    lookupAction: '/action',
    lookupActionTable: '/action/table',
    createAction: '/action',
    actionEdit: '/action',
    actionDelete: '/action',
  },

  actionofontology: {
    lookupActionOfOntology: '/actionofontology',
  },
  decisiveConditionofontology: {
    lookupDecisiveConditionOfOntology: '/decisiveConditionOfOntology',
  },

  kanban: {
    base: '/kanban',
    lookupKanban: '/kanban',
    lookupKanbanTable: '/kanban',
    createKanban: '/kanban',
    kanbanEdit: '/kanban',
    kanbanDelete: '/kanban',
    lookupKanbanOfOntology: '/kanban/kanban-of-ontology',
  },

  outcome: {
    base: '/outcome',
    lookupOutcome: '/outcome',
    lookupOutcomeTable: '/outcome/table',
    createOutcome: '/outcome',
    outcomeEdit: '/outcome',
    outcomeEditOverwrite: '/outcome/overwrite',
    outcomeDelete: '/outcome',
  },

  deliverable: {
    base: '/deliverable',
    lookupDeliverable: '/deliverable',
    lookupDeliverableTable: '/deliverable',
    createDeliverable: '/deliverable',
    deliverableEdit: '/deliverable',
    deliverableDelete: '/deliverable',
    lookupDeliverableOfOntology: '/deliverable/deliverable-of-ontology',
  },

  test: {
    base: '/test',
    lookupTest: '/test',
    lookupTestTable: '/test',
    createTest: '/test',
    testEdit: '/test',
    testDelete: '/test',
    lookupTestOfOntology: '/test/test-of-ontology',
  },

  outcomeofontology: {
    lookupOutcomenOfOntology: '/outcomeofontology',
  },

  observationTask: {
    base: '/observation-task',
    lookupObservationTask: '/observation-task',
    lookupObservationTaskTable: '/observation-task/table',
    createObservationTask: '/observation-task',
    observationTaskEdit: '/observation-task',
    observationTaskDelete: '/observation-task',
  },

  observationtaskofontology: {
    lookupObservationTaskOfOntology: '/observationtaskofontology',
    lookupObservationTaskOfUser: '/observationtaskofuser',
  },

  flow: {
    base: '/state',
    lookupState: '/state',
    stateAdd: '/state',
    stateAllAdd: '/state/stateAll',
    stateEdit: '/state',
    stateDelete: '/state',
  },

  fields: {
    lookupFields: 'fields',
  },

  logs: {
    lookupLogs: 'logs',
  },

  transaction: {
    base: '/transaction',
    lookupTransaction: '/transaction',
    transactionAdd: '/transaction',
    transactionEdit: '/transaction',
    transactionDelete: '/transaction',
  },

  trainingObjective: {
    base: '/trainingObjective',
    lookupTrainingObjective: '/trainingObjective',
    lookupTrainingObjectiveTable: '/trainingObjective/table',
    createTrainingObjective: '/trainingObjective',
    trainingObjectiveEdit: '/trainingObjective',
    trainingObjectiveDelete: '/trainingObjective',
    trainingObjectiveReport: '/trainingObjective/report',
    trainingObjectiveIncidentChart: '/trainingObjective/incidentChart',
    trainingObjectiveEditOverwrite: '/trainingObjective/overwrite',
  },

  trainingobjectiveofontology: {
    lookupTrainingObjectiveOfOntology: '/trainingobjectiveofontology',
  },

  configurationChangeRequest: {
    base: '/configuration-change-request',
    lookupConfigurationChangeRequest: '/configuration-change-request',
    createConfigurationChangeRequest: '/configuration-change-request',
    configurationChangeRequestEdit: '/configuration-change-request',
    configurationChangeRequestDelete: '/configuration-change-request',
    transformConfigurationChangeRequest: '/configuration-change-request/transform',
  },
  technicalSupportRequest: {
    base: '/technical-support-request',
    lookupTechnicalSupportRequest: '/technical-support-request',
    createTechnicalSupportRequest: '/technical-support-request',
    technicalSupportRequestEdit: '/technical-support-request',
    technicalSupportRequestDelete: '/technical-support-request',
  },

  troubleTicket: {
    base: '/trouble-ticket',
    lookupTroubleTicket: '/trouble-ticket',
    createTroubleTicket: '/trouble-ticket',
    troubleTicketEdit: '/trouble-ticket',
    troubleTicketDelete: '/trouble-ticket',
    transformTroubleTicket: '/trouble-ticket/transform',
  },
  registry: {
    base: '/registry',
    lookupRegistry: '/registry',
    createRegistry: '/registry',
    deleteRegistry: '/registry',
    editRegistry: '/registry',
  },
  parameter: {
    base: '/actor-books',
    lookupActorBook: '/actor-books/actorbook',
    lookupActors: '/actor-books/actors',
    lookupInstruments: '/actor-books/instruments',
    updateActorBook: '/actor-books/update',
    getParameters: '/actor-books/parameters',
    updatePmesii: '/actor-books/updatePmesii',
  },
  setting: {
    base: '/setting',
    lookupSetting: '/setting',
    createSetting: '/setting',
    deleteSetting: '/setting',
    editSetting: '/setting',
    exportSetting: '/setting/export',
    importSetting: '/setting/import',
  },

  lill: {
    base: '/lill',
    lookupLill: '/lill',
    createLill: '/lill',
    lillEdit: '/lill',
    lillDelete: '/lill',
  },

  experimentationAnalysis: {
    base: '/experimentation-analysis',
    lookupExperimentationAnalysis: '/experimentation-analysis',
    createExperimentationAnalysis: '/experimentation-analysis',
    createExperimentationAnalysisChartData: '/experimentation-analysis/chart-data',
    getExperimentationAnalysisChartData: '/experimentation-analysis/chart-data',
    getExperimentationAnalysisName: '/experimentation-analysis/analysis-name',
    updateExperimentationAnalysisName: '/experimentation-analysis/analysis-name',
    deleteExperimentationAnalysis: '/experimentation-analysis',
  },

  experimentation: {
    base: '/experimentation',
    lookupExperimentation: '/experimentation',
    lookupExperimentationTable: '/experimentation',
    createExperimentation: '/experimentation',
    editExperimentation: '/experimentation',
    deleteExperimentation: '/experimentation',
    deleteExperimentationWithoutFolder: '/experimentation/deleteWithoutFolder',
    getExperimentationChartData: '/experimentation/report',
  },

  battleRhythm: {
    base: '/battle-rhythm',
    lookupBattleRhythm: '/battle-rhythm',
    createBattleRhythm: '/battle-rhythm',
    editBattleRhythm: '/battle-rhythm',
    deleteBattleRhythm: '/battle-rhythm',
    lookupUsersOfBattleRhythm: '/battle-rhythm/usersOfBattleRhythm',
  },

  coa: {
    base: '/coa',
    lookupCoa: '/coa',
    createCoa: '/coa',
    editCoa: '/coa',
    deleteCoa: '/coa',
    unLinkAndRemoveSyncMatrix: '/coa/unlink-and-remove-sync-matrix',
  },

  syncMatrix: {
    base: '/sync-matrix',
    upsertSyncMatrix: '/sync-matrix',
    lookupSyncMatrix: '/sync-matrix',
    deleteSyncMatrix: '/sync-matrix',
    updateIsImported: '/sync-matrix/is-imported',
    lookupIsImported: '/sync-matrix/is-imported',
    unlinkCoa: '/sync-matrix/unlink-coa',
    removeTaskFromSyncMatrix: '/sync-matrix/removeTaskFromSyncMatrix',
  },

  coaAnalysis: {
    base: '/coa-analysis',
    lookupCoaAnalysis: '/coa-analysis',
    createCoaAnalysis: '/coa-analysis',
    editCoaAnalysis: '/coa-analysis',
    deleteCoaAnalysis: '/coa-analysis',
    createConcept: '/coa-analysis/concept',
  },

  risk: {
    base: '/risk',
    lookupRisk: '/risk',
    createRisk: '/risk',
    editRisk: '/risk',
    deleteRisk: '/risk',
  },

  resource: {
    base: '/resource',
    lookupResource: '/resource',
    createResource: '/resource',
    editResource: '/resource',
    deleteResourceAttachments: '/resource/deleteAttachments',
    deleteResource: '/resource',
  },

  permission: {
    base: '/permissions',
    lookupPermission: '/permissions',
    createPermission: '/permissions',
    editPermission: '/permissions',
    deletePermissionAttachments: '/permissions/deleteAttachments',
    deletePermission: '/permissions',
  },
  userRolePermission: {
    base: '/userrolepermission',
    lookupUserRolePermission: '/userrolepermission',
    createUserRolePermission: '/userrolepermission',
    editUserRolePermission: '/userrolepermission',
    deleteUserRolePermissionAttachments: '/userrolepermission/deleteAttachments',
    deleteUserRolePermission: '/userrolepermission',
  },
  comments: {
    base: '/comment',
    lookupComments: '/comment',
    createComments: '/comment',
    editComments: '/comment',
    deleteComments: '/comment',
  },

  messenger: {
    createCredentials: '/mailSettings/credentials',
    createMail: '/customMail',
    getPublicKey: '/mailSettings/getPubKey',
    createUserPassword: '/mailSettings/userPassword',
  },

  rlsmSavedSearches: {
    lookupSavedSearches: '/rlsm-saved-searches',
    createSavedSearch: '/rlsm-saved-searches',
    updateSavedSearch: '/rlsm-saved-searches',
    deleteSavedSearch: '/rlsm-saved-searches',
  },

  generics: {
    oyun: '/oyun',
    run: '/run',
    oyuncu: '/oyuncu',
    oyuncuBagliliklari: '/oyuncu-bagliliklari',
    oyuncuTipleri: '/oyuncu-tipleri-static',
    ulkerlerGeojson: '/ulkeler_geojson',
    safStrateji: '/saf-strateji',
    urunStrateji: '/urun-strateji',
    subSafStrateji: '/saf-strateji/sub',
    urunKategori: '/urun-kategori',
    urunBirim: '/urun-birim',
    ulasimYontemleri: '/ulasim-turleri',
    ulasimAglari: '/ulasim-aglari',
    ittifak: '/ittifak',
    urun: '/urun',
    senaryo: '/senaryo',
    dugum: '/dugum',
    baglanti: '/baglanti',
    warning: '/warnings',
    common: {
      etmen: '/etmen',
      etmenTurleri: '/etmen-turleri',
      etmenSiniflari: '/etmen-siniflari',
      tmkKalemiOzellikleri: '/tmk-kalemi-ozellikleri',
      aracFaydaliYukDenizHava: '/arac-faydali-yuk-deniz-hava',
      denizAraciGerekliIkmal: '/deniz-araci-gerekli-ikmal',
      denizAraciGerekliTmk: '/deniz-araci-gerekli-tmk',
      denizAraciTaraf: '/deniz-araci-taraf',
      denizAraciParametreleri: '/deniz-araci-parametreleri',
      dostZayiatIndeksi: '/dost-zayiat-indeksi',
      faydaliYuk: '/faydali-yuk',
      faydaliYukGerekli: '/faydali-yuk-gerekli',
      havaAraciGerekliIkmal: '/hava-araci-gerekli-ikmal',
      havaAraciGerekliTmk: '/hava-araci-gerekli-tmk',
      havaAraciTaraf: '/hava-araci-taraf',
      havaAraciParametreleri: '/hava-araci-parametreleri',
      ikmalCurumeIndeksler: '/ikmal-curume-indeksler',
      ikmalSiniflari: '/ikmal-siniflari',
      insanYapimiEngelTuru: '/insan-yapimi-engel-turu',
      muhabereCihaziTaraf: '/muhabere-cihazi-taraf',
      muhabereCihaziTuru: '/muhabere-cihazi-turu',
      quad: '/quad',
      taraflar: '/taraflar',
      taraflarArasiIliskiler: '/taraflar-arasi-iliskiler',
      tmkGerekliIkmal: '/tmk-gerekli-ikmal',
      tmkGerekliTmk: '/tmk-gerekli-tmk',
      tmkKalemiTaraf: '/tmk-kalemi-taraf',
      veritabani: '/veritabani',
      emir: '/emir',
      emirGruplari: '/emir-gruplari',
    },
    drawModule: {
      drawenLayers: '/drawen-layer',
      drawenLayerGroups: '/drawen-layer-group',
      drawenLayerGroupsLayer: '/drawen-layer-group-layer',
      geoJson: '/geoJson',
      drawenLayerGroupsTaraf: '/drawen-layer-group-taraf',
      drawenLayerGroupsLayerTaraf: '/drawen-layer-group-layer-taraf',
    },

    air: {
      havaKoridorlari: '/hava-koridorlari',
    },
    muhimmat: {
      arinmakKorunmakIcinGerekliIkmalMaddeleri: '/arinmak-korunmak-icin-gerekli-ikmal-maddeleri',
      havaSavunmaArac: '/hava-savunma-arac',
      havaSavunmaEtki: '/hava-savunma-etki',
      havaSavunmaEtkiMatrisi: '/hava-savunma-etki-matrisi',
      muhimmatGerekliIkmal: '/muhimmat-gerekli-ikmal',
      muhimmatIndeksler: '/muhimmat-indeksler',
      muhimmatTurleri: '/muhimmat-turleri',
      daza: '/daza',
      dazaIndeksler: '/daza-indeksler',
    },
    environment: {
      akintiIstikameti: '/akinti-istikameti',
      akintiSiddeti: '/akinti-siddeti',
      algilamaMesafeleri: '/algilama-mesafeleri',
      araziHavaIntikal: '/arazi-hava-intikal',
      araziHavaDuzeltme: '/arazi-hava-duzeltme',
      araziTuru: '/arazi-turu',
      aydinlik: '/aydinlik',
      bofor: '/bofor',
      dalgaIstikameti: '/dalga-istikameti',
      dalgaYuksekligi: '/dalga-yuksekligi',
      denizAraciAraziIntikal: '/deniz-araci-arazi-intikal',
      denizTrafikBolumlemeYoluDugumNoktasi: '/deniz-trafik-bolumleme-yolu-dugum-noktasi',
      derinlikBolgeleri: '/derinlik-bolgeleri',
      derinlikYukseklik: '/derinlik-yukseklik',
      dugum: '/dugum',
      engelOzellikleri: '/engel-ozellikleri',
      gelgitYuksekligi: '/gelgit-yuksekligi',
      gorusMesafesi: '/gorus-mesafesi',
      havaIrtifasi: '/hava-irtifasi',
      havaSicaklikKategorisi: '/hava-sicaklik-kategorileri',
      havaSavunmaMesafeleri: '/hava-savunma-mesafeleri',
      havayoluDugumNoktasi: '/havayolu-dugum-noktasi',
      irtifaBolgeleri: '/irtifa-bolgeleri',
      isikIstikametiParametreleri: '/isik-istikameti-parametreleri',
      isikSiddetiParametreleri: '/isik-siddeti-parametreleri',
      manyetikAnomaliDegerleri: '/manyetik-anomali-degerleri',
      ruzgarIstikameti: '/ruzgar-istikameti',
      ruzgarSiddeti: '/ruzgar-siddeti',
      suSavunmaMesafeleri: '/su-savunma-mesafeleri',
      trafikBolumlemeYollari: '/trafik-bolumleme-yollari',
      uzayHavasi: '/uzay-havasi',
      yagisMiktari: '/yagis-miktari',
      yagisTipi: '/yagis-tipi',
      yol: '/yol',
      yolDugum: '/yol-dugum',
      yolHavaIntikal: '/yol-hava-intikal',
      yolOzellikleri: '/yol-ozellikleri',
    },
  },

  import: {
    oyuncu: '/import/oyuncu',
    senaryo: '/import/senaryo',
    strateji: '/import/strateji',
    general: '/import',
  },
  oyun: {
    select: '/oyun/select',
  },

  oyuncu: {
    setgeojson: '/oyuncu/setgeojson',
  },

  degiskenler: {
    lookup: '/static-degiskenler',
    groupby: '/static-degiskenler/groupBy',
    uyum: '/uyum',
  },

  strateji: {
    lookup: '/strateji',
    groupby: '/strateji/groupBy',
  },

  oyuncuTipleri: {
    instruments: '/oyuncu-tipleri-static/instruments',
    parameters: '/oyuncu-tipleri-static/parameters',
  },

  export: {
    excel: '/export',
  },
  geostrategicSit: {
    get: '/geostrategic-sit',
    create: '/geostrategic-sit',
    delete: '/geostrategic-sit',
  },
  roadToCurrentSettings: {
    base: '/road-to-current-settings',
    lookupRoadToCurrentSettings: '/road-to-current-settings',
    createRoadToCurrentSettings: '/road-to-current-settings',
    updateRoadToCurrentSettings: '/road-to-current-settings',
    deleteRoadToCurrentSettings: '/road-to-current-settings',
    importRoadToCurrentSettings: '/road-to-current-settings/import',
  },
};

export default urlsConfig;
